export default "/images/phone-portrait.svg?e55a36920b78fdfbd928a612bcf47b2f";